import script from "./goRinSyo0049.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0049.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0049.vue?vue&type=style&index=0&id=6d4657d7&lang=scss"

const __exports__ = script;

export default __exports__